import React, { Component } from 'react'
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';

/* Json */
import { parse, stringifyFormatted, stringify, safeDeepGet } from 'iotera-base/json'
import { isEmpty } from 'iotera-base/object'

export default class JsonEditor extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this)
    let finalCode = {};
    let code = safeDeepGet(props, ['value'], {})
    let areaHeight = safeDeepGet(props, ['areaHeight'], 500)
    if (!isEmpty(code)) {
      finalCode = parse(code);
    }
    this.state = {
      code: stringifyFormatted(finalCode),
      areaHeight
    }
  }

  onChange(value) {
    let jsonValue = parse(value);
    let result = stringify(jsonValue)
    this.props.onChange(result)
    this.setState({
      code: value
    })
  }

  render() {
    const _this = this
    const _state = _this.state
    const { code, areaHeight } = _state
    if (code !== undefined) {
      return (
        <div className="container_editor_area">
          <Editor
            value={code}
            onValueChange={(code) => _this.onChange(code)
            }
            className="container__editor"
            highlight={() => highlight(code, languages.js)}
            padding={10}
            style={{
              minHeight: areaHeight
            }}
          />
        </div>
      );
    } else {
      return (
        <div />
      )
    }
  }
}